import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { QueryContext } from 'customer-data-sidebar/universal/context/QueryContext';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useLegacyCardDataRequest } from './useLegacyCardDataRequest';
import { LEGACY_SIDEBAR_CARDS_WITH_PERFORMANCE_MARKERS } from './LegacySidebarCardsWithPerformanceMarkers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function LegacySidebarComponentWithDataRequest(props) {
  const {
    objectId,
    objectTypeId,
    cardData,
    CardComponent,
    extraProps = {},
    isEditable,
    renderLoadingIndicator,
    renderErrorState,
    SuccessMarker,
    ErrorMarker,
    CardContentLoadingComponent,
    cardType
  } = props;
  const queryResult = useLegacyCardDataRequest({
    objectTypeId,
    objectId,
    cardId: cardData.cardId
  });
  if (!queryResult.data && queryResult.loading) {
    if (!renderLoadingIndicator) {
      return null;
    }
    return renderLoadingIndicator();
  }
  if (queryResult.error) {
    if (renderErrorState) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [ErrorMarker && /*#__PURE__*/_jsx(ErrorMarker, {}), renderErrorState(queryResult.error)]
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [ErrorMarker && /*#__PURE__*/_jsx(ErrorMarker, {}), /*#__PURE__*/_jsx(ErrorMessage, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "legacySidebarCard.loadingError"
        })
      })]
    });
  }
  const objectTypeName = ObjectTypeFromIds[objectTypeId];
  return /*#__PURE__*/_jsxs(QueryContext.Provider, {
    value: queryResult,
    children: [SuccessMarker && !LEGACY_SIDEBAR_CARDS_WITH_PERFORMANCE_MARKERS.has(cardType) && /*#__PURE__*/_jsx(SuccessMarker, {}), /*#__PURE__*/_jsx(CardComponent, Object.assign({
      data: queryResult.data.crmObject.card,
      ErrorMarker: ErrorMarker,
      isEditable: isEditable,
      objectId: `${objectId}`,
      objectType: objectTypeName || objectTypeId,
      subjectId: `${objectId}`,
      SuccessMarker: SuccessMarker,
      CardContentLoadingComponent: CardContentLoadingComponent,
      renderLoadingIndicator: renderLoadingIndicator
    }, extraProps))]
  });
}
export default LegacySidebarComponentWithDataRequest;